// extracted by mini-css-extract-plugin
export default {"article":"components-Macro-styles__article--tUgrD"};